import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';

export default {
    fields: ['name', 'description'],
    fields: {
        name: {
            component: LinkTitleComponent,
        }
    },
    sortable: [],
    pagination: true,
    searchable: true,
    treeView: false,
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        // {
        //     name: 'delete',
        //     component: 'delete-button',
        // },
        // {
        //     name: 'active',
        //     component: 'active-switch-action-component',
        // },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.roles.js